import DeviceIssueErrorDetailsModal from '@/components/deviceIssue/DeviceIssueErrorDetailsModal';
import { Popper } from '@mui/material';
import PropTypes from 'prop-types';

export const DeviceErrorPopper = ({ open, anchorEl, record, onMouseLeave }) => (
    <Popper
        id={open ? 'error-details-popper' : undefined}
        open={open}
        anchorEl={anchorEl}
        placement='bottom'
        disableScrollLock
        modifiers={[
            {
                name: 'offset',
                options: {
                    offset: [0, 14],
                },
            },
            {
                name: 'preventOverflow',
                options: {
                    boundary: 'clippingParents',
                    rootBoundary: 'viewport',
                    padding: 8,
                    altAxis: true,
                },
            },
        ]}
        sx={{
            zIndex: 9999,
            '& ::after': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: '-14px',
                left: 0,
                width: '100%',
                height: 'calc(100% + 28px)',
                backgroundColor: 'transparent',
                zIndex: -1,
            },
        }}
        onMouseLeave={onMouseLeave}
    >
        <DeviceIssueErrorDetailsModal record={record} />
    </Popper>
);

DeviceErrorPopper.propTypes = {
    open: PropTypes.bool.isRequired,
    anchorEl: PropTypes.object,
    record: PropTypes.shape({
        id: PropTypes.string.isRequired,
        collectionPointId: PropTypes.string,
        collectionPoint: PropTypes.shape({
            id: PropTypes.string.isRequired,
            contractorId: PropTypes.string.isRequired,
            serviceCompanyId: PropTypes.string,
            contractor: PropTypes.shape({
                id: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            }).isRequired,
            customId: PropTypes.string.isRequired,
            premiumService: PropTypes.bool.isRequired,
            address: PropTypes.shape({
                address: PropTypes.string.isRequired,
                city: PropTypes.string.isRequired,
                postalCode: PropTypes.string.isRequired,
                country: PropTypes.string.isRequired,
            }).isRequired,
            contact: PropTypes.shape({
                contactPhoneNumber: PropTypes.string.isRequired,
            }).isRequired,
        }),
        serialNumber: PropTypes.string,
        state: PropTypes.string,
        occurredAt: PropTypes.string,
        error: PropTypes.shape({
            code: PropTypes.number,
            name: PropTypes.string,
            level: PropTypes.number,
            title: PropTypes.string,
            solutionTip: PropTypes.string,
            time: PropTypes.string,
            details: PropTypes.string,
        }),
    }),
    onMouseLeave: PropTypes.func.isRequired,
};
